"use strict";

// ============================================================================
// CONFIGURATION
// ============================================================================

const SHOPIFY_CONFIG = {
  apiUrl: "https://64audio.myshopify.com/api/2023-10/graphql.json",
  accessToken: "2431c3caa2a5a70559ff66ef79b2c07e",
};

const IMPRESSION_STATUS_OPTIONS = [
  "Sending in new impressions",
  "Impressions on file from previous order",
  "Already sent Impressions",
];

const DEFAULT_CUSTOMER_INFO = {
  "Left Shell": "Translucent Clear",
  "Right Shell": "Translucent Clear",
  "Left Faceplate": "Translucent Clear",
  "Right Faceplate": "Translucent Clear",
  "Left Artwork": "64 Audio Silver Logos",
  "Right Artwork": "64 Audio Silver Logos",
  "Socket Type": "IPX",
  "Cable Color": "Black",
  "Cable Length": '48"',
  "Case Type": "64 Audio Aluminum Case",
  //"Text On Case": "No",
  Preview:
    "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/BlackFriday-Clear-Accessories-1.jpg?v=1700004365",
};

const clearModelDetails = {
  A2e: {
    title: "A2e",
    driverCount: "2",
    msrp: "$549.00",
    img: "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/Radar-Chart_A2e.png?v=1764005599",
    description: `The most advanced two-driver custom in-ear monitor on the market.`,
    tech: "3D-Fit • LID • apex",
    inTheBox:
      'A2e Custom In-Ear Monitors - Aluminum Case - Dehumidifier - Cleaning Tool - Shirt Clip - 48" Black IPX Professional Cable - m20 apex™ Modules - Round Sticker - Product Manual',
  },
  A3e: {
    title: "A3e",
    driverCount: "3",
    msrp: "$749.00",
    img: "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/Radar-Chart_A3t.png?v=1700263306",
    description: `Our versatile, three-driver custom in-ear monitor provides impressive clarity and warmth for any instrument or genre.`,
    tech: "3D-Fit • LID • apex",
    inTheBox:
      'A3e Custom In-Ear Monitors - Aluminum Case - Dehumidifier - Cleaning Tool - Shirt Clip - 48" Black IPX Professional Cable - m20 apex™ Modules - Round Sticker - Product Manual',
  },
  A3t: {
    title: "A3t",
    driverCount: "3",
    msrp: "$949.00",
    img: "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/Radar-Chart_A3t.png?v=1700263306",
    description: `The most affordable reference-grade tool for any audio engineer or musician looking for a neutral, balanced and musical monitor for live and recorded performances.`,
    tech: "3D-Fit • tia • LID • apex",
    inTheBox:
      'A3t Custom In-Ear Monitors - Aluminum Case - Dehumidifier - Cleaning Tool - Shirt Clip - 48" Black IPX Professional Cable - m20 apex™ Modules - Round Sticker - Product Manual',
  },
  A4s: {
    title: "A4s",
    driverCount: "4",
    msrp: "$1,199.00",
    img: "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/Radar-Chart_A4s.png?v=1700263306",
    description: `A hybrid IEM elevated by its Dynamic low frequency driver. Deep enveloping bass coupled with extended airy highs.`,
    tech: "3D-Fit • tia • LID • apex",
    inTheBox:
      'A4s Custom In-Ear Monitors - Aluminum Case - Dehumidifier - Cleaning Tool - Shirt Clip - 48" Black IPX Professional Cable - m20 apex™ Modules - Round Sticker - Product Manual',
  },
  A6t: {
    title: "A6t",
    driverCount: "6",
    msrp: "$1,399.00",
    img: "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/Radar-Chart_A6t.png?v=1700263306",
    description: `A favorite among multi-instrumentalists and audio engineers for its extended highs, smooth mids, defined lower-mids and powerful lows. Our most popular CIEM.`,
    tech: "3D-Fit • tia • LID • apex",
    inTheBox:
      'A6t Custom In-Ear Monitors - Aluminum Case - Dehumidifier - Cleaning Tool - Shirt Clip - 48" Black IPX Professional Cable - m20 apex™ Modules - Round Sticker - Product Manual',
  },
  N8: {
    title: "N8",
    driverCount: "9",
    msrp: "$1,699.00",
    img: "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/Radar-Chart_N8.png?v=1700263306",
    description: `Created in collaboration with legendary bassist, Nathan East. A warm sounding hybrid IEM with immense bass headroom, saturated lower-mids, smooth mids and detailed highs.`,
    tech: "3D-Fit • tia • LID • apex",
    inTheBox:
      'N8 Custom In-Ear Monitors - Aluminum Case - Dehumidifier - Cleaning Tool - Shirt Clip - 48" Black IPX Professional Cable - m15 apex™ Modules - Round Sticker - Product Manual',
  },
  A12t: {
    title: "A12t",
    driverCount: "12",
    msrp: "$1,999.00",
    img: "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/Radar-Chart_A12t.png?v=1700263306",
    description: `A studio reference monitor designed to withstand the rigors of live performance monitoring. Balanced, natural, and musical while being articulate in the upper-mids and punchy in the lows.`,
    tech: "3D-Fit • tia • LID • apex",
    inTheBox:
      'A12t Custom In-Ear Monitors - Aluminum Case - Dehumidifier - Cleaning Tool - Shirt Clip - 48" Black IPX Professional Cable - m20 apex™ Modules - Round Sticker - Product Manual',
  },
  A18t: {
    title: "A18t",
    driverCount: "18",
    msrp: "$2,999.00",
    img: "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/Radar-Chart_A18t.png?v=1700263306",
    description: `The most accurate and highest resolution CIEM in the world. Detailed and quick like a mastering grade reference monitor. Delicate enough for critical audiophile listeners with the clarity to meet the demands of the most discerning performers.`,
    tech: "3D-Fit • tia • apex",
    inTheBox:
      'A18t Custom In-Ear Monitors - Aluminum Case - Dehumidifier - Cleaning Tool - Shirt Clip - 48" Black IPX Professional Cable - m20 apex™ Modules - Round Sticker - Product Manual',
  },
  A18s: {
    title: "A18s",
    driverCount: "18",
    msrp: "$2,999.00",
    img: "https://cdn.shopify.com/s/files/1/0411/4717/0966/files/Radar-Chart_A18s.png?v=1700263306",
    description: `The most capable and versatile in-ear monitor ever created. A warmer reference monitor tonality you can trust to mix a record on with more headroom and power than you would ever need for the loudest of live performance environments.`,
    tech: "3D-Fit • tia • LID • apex",
    inTheBox:
      'A18s Custom In-Ear Monitors - Aluminum Case - Dehumidifier - Cleaning Tool - Shirt Clip - 48" Black IPX Professional Cable - m20 apex™ Modules - Round Sticker - Product Manual',
  },
};

// ============================================================================
// GRAPHQL QUERIES
// ============================================================================

const FETCH_PRODUCT_QUERY = `
  query fetchClearProduct($title: String) {
    products(query: $title, first: 1) {
      edges {
        node {
          id
          title
          productType
          variants(first: 10) {
            nodes {
              id
              title
              priceV2 {
                amount
                currencyCode
              }
            }
          }
          media(first: 10) {
            edges {
              node {
                mediaContentType
                alt
                ...mediaFieldsByType
              }
            }
          }
        }
      }
    }
  }

  fragment mediaFieldsByType on Media {
    ... on ExternalVideo {
      id
      originUrl
    }
    ... on MediaImage {
      image {
        url
      }
    }
    ... on Model3d {
      sources {
        url
        mimeType
        format
        filesize
      }
    }
    ... on Video {
      sources {
        url
        mimeType
        format
        height
        width
      }
    }
  }
`;

// ============================================================================
// API FUNCTIONS
// ============================================================================

/**
 * Fetches data from Shopify GraphQL API
 */
async function fetchShopifyData(query, variables) {
  try {
    const response = await fetch(SHOPIFY_CONFIG.apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": SHOPIFY_CONFIG.accessToken,
      },
      body: JSON.stringify({ query, variables }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const jsonResponse = await response.json();

    if (jsonResponse.errors) {
      throw new Error(`GraphQL errors: ${JSON.stringify(jsonResponse.errors)}`);
    }

    return jsonResponse.data;
  } catch (error) {
    console.error("Error fetching from Shopify:", error);
    throw error;
  }
}

/**
 * Parses product variants into a simplified model array
 */
function parseProductVariants(data) {
  if (!data?.products?.edges?.[0]?.node?.variants?.nodes) {
    throw new Error("Invalid product data structure");
  }

  const variants = data.products.edges[0].node.variants.nodes;

  const models = variants.map((variant) => {
    const idParts = variant.id.split("/");
    return {
      id: idParts[idParts.length - 1],
      title: variant.title,
      price: parseFloat(variant.priceV2.amount).toFixed(2),
    };
  });

  // Sort by price (ascending)
  return models.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
}

/**
 * Fetches Clear CIEM products from Shopify
 */
async function fetchClearCIEMs(productTitle) {
  const data = await fetchShopifyData(FETCH_PRODUCT_QUERY, {
    title: productTitle,
  });
  return parseProductVariants(data);
}

// ============================================================================
// DOM UTILITIES
// ============================================================================

/**
 * Gets product title from DOM
 */
function getProductTitle() {
  const productTitleElement = document.getElementById("product-title");
  return productTitleElement?.textContent?.trim() || "";
}

/**
 * Updates the displayed price
 */
function updatePrice(price) {
  const priceElement = document.getElementById("clear-model-price");
  if (priceElement) {
    priceElement.textContent = `$${price}`;
  }
}

/**
 * Changes the active tab
 */
function changeTab(tabIndex) {
  // Update tab buttons
  const tabButtons = Array.from(document.getElementsByClassName("tab-btn"));
  tabButtons.forEach((button, index) => {
    button.classList.toggle("tab-btn-active", index === tabIndex);
  });

  // Update tab content
  const tabs = Array.from(document.getElementsByClassName("custom-info-tab"));
  tabs.forEach((tab) => tab.classList.remove("custom-info-tab-active"));

  const selectedTab = document.getElementById(
    `custom-info-tab-${tabIndex + 1}`
  );
  if (selectedTab) {
    selectedTab.classList.add("custom-info-tab-active");
  }
}

// ============================================================================
// TEMPLATE FUNCTIONS
// ============================================================================

/**
 * Renders model specifications
 */
function renderModelSpecs(model) {
  const container = document.getElementById("customs-info-container");
  if (!container || !model) return;

  container.innerHTML = `
    <div class="bf-specification-container">
      <div class="flex flex-column model-card">
        <div class="flex space-around ci-py-5">
          <div class="flex align-center justify-center">
            <h3 class="text-bold rem-1-5 font-bold mg-block-start mb-0" name="${model.title}" aria-label="model">
              ${model.title}
            </h3>
          </div>
          <div class="flex align-center justify-center">
            <p class="rem-1-3 mt-0">${model.driverCount} Drivers</p>
          </div>
          <div class="flex align-center justify-center">
            <p class="rem-1-3 mt-0">MSRP: ${model.msrp}</p>
          </div>
        </div>
        <div class="justify-center py-40" id="model-info-container">
          <img class="chart max-height-500" src="${model.img}" alt="${model.title} radar chart">
        </div>
        <div class="flex flex-column justify-center align-center py-40 w-80">
          <p class="text-align-center p-light font-weight-600">${model.tech}</p>
          <p class="text-align-center p-light py-10">${model.description}</p>
        </div>
      </div>
    </div>
  `;
}

/**
 * Renders "In the Box" information
 */
function renderInTheBoxInfo(model) {
  const container = document.getElementById("in-the-box-container");
  if (!container || !model) return;

  container.innerHTML = `
    <div class="flex flex-column justify-center align-center">
      <p>${model.inTheBox}</p>
    </div>
  `;
}

/**
 * Generates initials from full name
 */
function generateInitials(fullName) {
  const parts = fullName.trim().split(/\s+/);
  if (parts.length < 2) return "";
  return (parts[0][0] || "") + (parts[1][0] || "");
}

// ============================================================================
// FORM MANAGEMENT
// ============================================================================

/**
 * Creates customer info object for cart
 */
function createCustomerInfo(model, impressionsStatus, userName) {
  return {
    model: model.title,
    modelid: model.id,
    "Impressions Status": impressionsStatus,
    "User Name": userName,
    "User Initials": generateInitials(userName),
    "Text On Case": userName,
    ...DEFAULT_CUSTOMER_INFO,
  };
}

/**
 * Renders the Clear CIEM selection form
 */
function renderForm(models, onModelChange, onSubmit) {
  const formWrapper = document.getElementById("clear-models-form-wrapper");
  if (!formWrapper) return;

  const modelOptions = models
    .map((model) => `<option value="${model.title}">${model.title}</option>`)
    .join("");

  const impressionOptions = IMPRESSION_STATUS_OPTIONS.map(
    (option) => `<option value="${option}">${option}</option>`
  ).join("");

  formWrapper.innerHTML = `
    <form id="clear-models-form">
      <div class="width-full bf-form-container gap-20">
        <label class="width-full pt-20 bf-form-text">Model</label>
        <select class="bf-form-input width-full" id="select-clear">
          ${modelOptions}
        </select>
        <label class="width-full bf-form-text">Impressions Status</label>
        <select class="bf-form-input width-full" id="imp-status">
          ${impressionOptions}
        </select>
        <label class="width-full bf-form-text">Full Name</label>
        <input class="bf-form-input" id="full-name" type="text" name="Full Name" required>
        <button class="pill-btn" id="add-to-cart-bt" type="submit">Add to Cart</button>
      </div>
    </form>
  `;

  // Attach event listeners
  const form = document.getElementById("clear-models-form");
  const modelSelect = document.getElementById("select-clear");
  const impressionsSelect = document.getElementById("imp-status");
  const fullNameInput = document.getElementById("full-name");

  if (modelSelect) {
    modelSelect.addEventListener("change", (e) => {
      const selectedModel = models.find((m) => m.title === e.target.value);
      if (selectedModel) {
        onModelChange(selectedModel);
      }
    });
  }

  if (form) {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const selectedModel = models.find((m) => m.title === modelSelect.value);
      const impressionsStatus = impressionsSelect.value;
      const userName = fullNameInput.value.trim();

      if (selectedModel && userName) {
        await onSubmit(selectedModel, impressionsStatus, userName);
      }
    });
  }
}

// ============================================================================
// CART FUNCTIONS
// ============================================================================

/**
 * Adds item to Shopify cart
 */
async function addToCart(customerInfo) {
  const { model: title, modelid: id, ...properties } = customerInfo;

  try {
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id,
            quantity: 1,
            properties,
          },
        ],
      }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        errorData.message || `Failed to add to cart: ${response.status}`
      );
    }

    // Redirect to cart on success
    window.location.href = `${window.location.origin}/cart`;
  } catch (error) {
    console.error("Error adding to cart:", error);
    alert("Failed to add item to cart. Please try again.");
  }
}

// ============================================================================
// MAIN APPLICATION
// ============================================================================

/**
 * Initializes the Clear CIEM form application
 */
async function initClearCIEMApp() {
  try {
    // Fetch product data
    const productTitle = getProductTitle();
    const models = await fetchClearCIEMs(productTitle);
    if (!models || models.length === 0) {
      throw new Error("No Clear CIEM models found");
    }

    // Set initial model
    let currentModel = models[0];
    updatePrice(currentModel.price);

    // Initialize tab
    changeTab(0);

    // Update specs and info for initial model
    const modelDetails = clearModelDetails[currentModel.title];
    if (modelDetails) {
      renderModelSpecs(modelDetails);
      renderInTheBoxInfo(modelDetails);
    }

    // Handle model changes
    const handleModelChange = (newModel) => {
      currentModel = newModel;
      updatePrice(newModel.price);

      const details = clearModelDetails[newModel.title];
      if (details) {
        renderModelSpecs(details);
        renderInTheBoxInfo(details);
      }
    };

    // Handle form submission
    const handleFormSubmit = async (model, impressionsStatus, userName) => {
      const customerInfo = createCustomerInfo(
        model,
        impressionsStatus,
        userName
      );
      await addToCart(customerInfo);
    };

    // Render form
    renderForm(models, handleModelChange, handleFormSubmit);
    // Log product title for debugging
    if (productTitle) {
      console.log("Product title:", productTitle);
    }
  } catch (error) {
    console.error("Failed to initialize Clear CIEM app:", error);
  }
}

// Initialize on page load
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initClearCIEMApp);
} else {
  initClearCIEMApp();
}
